module.exports = __webpack_public_path__ + "static/media/ECO2.2e62ace9.svg";